import { Controller } from 'stimulus';
import Animation from 'src/animation';

import sprite1 from 'images/animations/axle_spacing/1.png';
import sprite2 from 'images/animations/axle_spacing/2.png';
import sprite3 from 'images/animations/axle_spacing/3.png';
import sprite4 from 'images/animations/axle_spacing/4.png';
import sprite5 from 'images/animations/axle_spacing/5.png';
import sprite6 from 'images/animations/axle_spacing/6.png';
import sprite7 from 'images/animations/axle_spacing/7.png';
import sprite8 from 'images/animations/axle_spacing/8.png';

export default class extends Controller {
  connect() {
    const ratio = 2.2;

    const options = {
      canvasWidth: this.element.offsetWidth,
      canvasHeight: this.element.offsetWidth / ratio,
      sources: this.sources,
      steps: this.steps,
      element: this.element
    };

    let rangeEl = this.element.querySelector('input')

    rangeEl.min = 0;
    rangeEl.max = 7;
    rangeEl.step = 1;
    rangeEl.value = 0;

    const animation = new Animation(options);

    let initialSprite = new Image();
    initialSprite.src = sprite1;
    initialSprite.onload = function() {
      animation.render(0)
    }
  }

  get sources() {
    return [
      sprite1,
      sprite2,
      sprite3,
      sprite4,
      sprite5,
      sprite6,
      sprite7,
      sprite8
    ]
  }

  get steps() {
    return [
      "Federal regulations for a normal tandem allows 34K based on the <a href='/regulations/federal-bridge-formula-calculator' target='_blank'>Federal Bridge Formula</a> (the standard for all commercial vehicles). Most states will allow you more than that with a permit.",
      'Generally you get a higher legal weight limit for a single axle than for an axle group, so sliding axles apart will allow you to carry more weight with the same number of axles.',
      'Generally you get a higher legal weight limit for a single axle than for an axle group, so sliding axles apart will allow you to carry more weight with the same number of axles.',
      'Generally anything under 8\'6" is considered an axle group, and will be given a certain weight limit, different in every state.',
      'But states have different limits for what they consider axle groups or single axles, so something that is cosnidered two singles in Texas will still be a tandem in Arizona as they have higher spacing requirements.',
      'Once you cross that spacing requirement, you can then carry a higher legal or permitted weight, for example in Texas you can carry 34k pounds on a tandem, but 20k+20k on two singles.',
      'Always check your axle spacings and your single and axle group limits in every state you go through to avoid costly overweight fines. ',
      "The easiest way to check axle weights in every state is by using the axle weight calculator below."
    ]
  }
}
